import type { FC } from "react";

interface RequiredLabelProps {
  text: string;
}

const RequiredLabel: FC<RequiredLabelProps> = ({ text }) => (
  <>
    {text} <span style={{ color: "#ff4d4f" }}>*</span>
  </>
);

export default RequiredLabel;
